// actions
// eslint-disable-next-line import/no-cycle
import { deleteDirectionsError } from '../../Directions/actions';

// helpers
import { makeActionCreator } from '../../../lib/Utils';

export const ERRORMSG_HYDRATE_ERRORS = 'ERRORMSG_HYDRATE_ERRORS';
export const hydrateErrorMsgErrors = makeActionCreator(
  ERRORMSG_HYDRATE_ERRORS,
  'data',
);

export const ERRORMSG_CREATE_ERROR = 'ERRORMSG_CREATE_ERROR';
export const createErrorMsgError = makeActionCreator(
  ERRORMSG_CREATE_ERROR,
  'errorMsg',
);

export const ERRORMSG_DELETE_ERROR = 'ERRORMSG_DELETE_ERROR';
const deleteErrorMsgError = makeActionCreator(ERRORMSG_DELETE_ERROR);
export function deleteErrorMessages() {
  // eslint-disable-next-line arrow-parens
  return dispatch => {
    dispatch(deleteErrorMsgError());
    dispatch(deleteDirectionsError());
    // TODO: remove more errors...
  };
}
